import AuthOptions from './AuthOptions';

export default AuthOptions;
